import styled from 'styled-components';
import { tokens } from '@mindtickle/styles/lib';

interface StyledLayoutWrapperProps {
  sectionCount: 2 | 3;
}

export const StyledLayoutWrapper = styled.div<StyledLayoutWrapperProps>`
  display: grid;
  padding: 0 24px;
  grid-template-columns: ${({ sectionCount }) => `repeat(${sectionCount}, 1fr)`};
  grid-template-rows: auto;
  background-color: ${tokens.bgTokens.COLOR_BG_DEFAULT};
  border-bottom: 1px solid ${tokens.borderTokens.COLOR_BORDER_SECONDARY};
  grid-column-gap: 24px;
  min-height: 56px;

  .left-section {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    min-width: 0;
  }

  .center-section {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 608px;
    min-width: 309px;
  }

  .right-section {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
